import React, { useState } from 'react'
import LoginForm from './LoginForm'
import CheckEmailPage from './CheckEmailPage'

/**
 * USOKIE Platform Authentication
 * Two-column editorial layout with dramatic branding
 */
const Login = () => {
  const [view, setView] = useState('form') // 'form' | 'check-email'
  const [email, setEmail] = useState('')

  const handleLoginSuccess = (submittedEmail) => {
    setEmail(submittedEmail)
    setView('check-email')
  }

  const handleBackToLogin = () => {
    setView('form')
    setEmail('')
  }

  return (
    <div className="min-h-screen bg-black flex">
      {/* Left Column - Branding */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        {/* Subtle grid overlay */}
        <div
          className="absolute inset-0 pointer-events-none opacity-[0.02]"
          style={{
            backgroundImage: `
              linear-gradient(to right, #fffbf7 1px, transparent 1px),
              linear-gradient(to bottom, #fffbf7 1px, transparent 1px)
            `,
            backgroundSize: '80px 80px'
          }}
        />

        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-black via-[#0a0a0a] to-black" />

        {/* Large symbol */}
        <div className="absolute inset-0 flex items-center justify-center">
          <img
            src="/images/usokie-symbol-sage.png"
            alt=""
            className="w-[60%] max-w-[400px] h-auto opacity-[0.12]"
            aria-hidden="true"
          />
        </div>

        {/* Branding content */}
        <div className="relative z-10 flex flex-col justify-between p-16 w-full">
          {/* Top - Logo */}
          <div>
            <img
              src="/images/usokie-logo-bone.png"
              alt="USOKIE"
              className="w-48 h-auto opacity-90"
            />
          </div>

          {/* Bottom - Tagline */}
          <div>
            <p
              className="text-2xl text-[#fffbf7] tracking-[0.02em] leading-relaxed mb-8"
              style={{ fontFamily: "'GT Pressura Mono', monospace" }}
            >
              Licensing.<br />
              Intelligence.<br />
              Reinvented.
            </p>
            <div className="w-24 h-px bg-[#a1c6a2]" />
          </div>
        </div>

        {/* Decorative border */}
        <div className="absolute right-0 top-0 bottom-0 w-px bg-[rgba(255,251,247,0.08)]" />
      </div>

      {/* Right Column - Form */}
      <div className="w-full lg:w-1/2 min-h-screen flex items-center justify-center relative">
        {/* Subtle grid overlay for mobile */}
        <div
          className="absolute inset-0 pointer-events-none opacity-[0.015] lg:hidden"
          style={{
            backgroundImage: `
              linear-gradient(to right, #fffbf7 1px, transparent 1px),
              linear-gradient(to bottom, #fffbf7 1px, transparent 1px)
            `,
            backgroundSize: '60px 60px'
          }}
        />

        {/* Content */}
        <div className="relative z-10 w-full max-w-lg px-8 py-16 lg:px-16">
          {view === 'form' && (
            <LoginForm onSuccess={handleLoginSuccess} />
          )}

          {view === 'check-email' && (
            <CheckEmailPage email={email} onBack={handleBackToLogin} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Login
